import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ToastService {
  // Common params for toast
  timeOut: number;
  extendedTimeOut: number;
  closeButton: boolean;
  progressBar: boolean;
  tapToDismiss: boolean;

  errorTimeOut: number;
  errorExtendedTimeOut: number;
  errorCloseButton: boolean;
  errorProgressBar: boolean;

  enableHtml: boolean;
  toasterOptions: any;
  toasterErrorOptions: any;

  constructor(
    private toastService: ToastrService,
    private translateService: TranslateService
  ) {
    // Params
    this.timeOut = 3000;
    this.extendedTimeOut = 1000;
    this.closeButton = true;
    this.progressBar = true;
    this.enableHtml = true;
    this.tapToDismiss = false;

    this.errorTimeOut = 40000;
    this.errorExtendedTimeOut = 40000;
    this.errorCloseButton = true;
    this.errorProgressBar = true;

    // Toaster options
    this.toasterOptions = {
      tapToDismiss: this.tapToDismiss,
      timeOut: this.timeOut,
      extendedTimeOut: this.extendedTimeOut,
      closeButton: this.closeButton,
      progressBar: this.progressBar,
      enableHtml: this.enableHtml,
    };

    // Toaster error options
    this.toasterErrorOptions = {
      tapToDismiss: this.tapToDismiss,
      timeOut: this.errorTimeOut,
      extendedTimeOut: this.errorExtendedTimeOut,
      closeButton: this.errorCloseButton,
      progressBar: this.errorProgressBar,
      enableHtml: this.enableHtml,
    };
  }

  // New toast by type with title and subtitle params
  new(type: string, title: string, subtitle: string, options?: any) {
    if (options) {
      this.toasterOptions = options;
    }
    if (!title) {
      title = '';
    }
    if (!subtitle) {
      this.translateService
        .get('COMMON.MESSAGE_NOT_DEFINED')
        .subscribe((res) => {
          subtitle = res;
        });
    }
    switch (type) {
      case 'success':
        this.toastService.success(
          subtitle.toString(),
          title.toString(),
          this.toasterOptions
        );
        break;
      case 'warning':
        this.toastService.warning(
          subtitle.toString(),
          title.toString(),
          this.toasterOptions
        );
        break;
      case 'error':
        this.toastService.error(
          subtitle.toString(),
          title.toString(),
          this.toasterErrorOptions
        );
        break;
      case 'info':
        this.toastService.info(
          subtitle.toString(),
          title.toString(),
          this.toasterOptions
        );
        break;
      default:
        console.error('[new] option not valid');
        break;
    }
  }

  clear() {
    this.toastService.clear();
  }
}
